import globals from '../../common/globals';

export default {
  name: 'vx-404-page',
  components: {},
  props: {
    i18n: {
      type: Object,
    },
  },
  data() {
    return {
      globals,
    };
  },
  computed: {

  },
  async mounted() {

  },
  methods: {
    /**
      * On click of return to home page.
      * if it is a gpXpress site user is navigated to catergory page else to home page.
     */
    goToHomePage() {
      if (globals.isGpXpress()) {
        globals.navigateToUrl('category');
      } else {
        globals.navigateToUrl('home');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/nfr/vx-404-page/vx-404-page.js